export default __webpack_public_path__ + "static/media/leg-right-side.af4c39cc.png";